import { TableName } from "../../../tables"

export enum DeliveryMethod {
    PICKUP = 'Pickup',
    RECEPTION = 'Reception',
    RETURN = 'Return',
    SHIPMENT = 'Shipment'
}

export enum DeliveryStatus {
    PENDING = 'Pending',
    PARTIALLY_DELIVERED = 'Partially Delivered',
    DELIVERED = 'Delivered'
}

export type DeliveryItemDeliveryStats = {
    toBeDelivered: number
    pending: number
    dispatched: number
    delivered: number
    cancelled?: number
    returned?: number
}

export type DeliveryOrderItem = {
    itemId: string
    quantity: number
    deliveryStats: DeliveryItemDeliveryStats
}

export type NotDeliveredItem = {
    itemId: string
    quantity: number
}

export type DeliveryOrder = {
    companyId: string
    id: string
    code: number
    codeStr: string
    table: TableName
    operationId: string
    method: DeliveryMethod
    items: DeliveryOrderItem[]
    creationDate: string
    deliveryDate: string
    supplierId?: string
    customerId?: string
    branchId: string
    addressId: string
    deliveryStatus: DeliveryStatus
    notDeliveredCount?: NotDeliveredItem[]
    cancelled?: boolean
    negativeStateUserId?: string
    negativeStateAt?: string
}

export type DeliveryItem = {
    itemId: string
    quantity: number
    deliveredQuantity: number
    notDeliveredQuantity: number
    defectiveQuantity?: number
}

export type Delivery = {
	companyId: string
    id: string
    code: number
    codeStr?: string
    table: TableName
    operationId: string
    orderId?: string
    method: DeliveryMethod
    items: DeliveryItem[]
    creationDate: string
    date: string
    customerId?: string
    branchId: string
    addressId: string
    deliveryStatus: DeliveryStatus
    deliveryNoteUrl?: string
    supplierDeliveryNoteNumber?: string
    fromNotDeliveredItems?: NotDeliveredItem[]
    cancelled?: boolean
    negativeStateUserId?: string
    negativeStateAt?: string
}

export type DeliveryData = {
    method: DeliveryMethod
    addressId?: string
    deliveryDate?: string
}
